import "./Navbar.css";
import { NavLink } from "react-router-dom";
import image from "../asset/undraw_Code_review_re_woeb.png";
function Navbar() {
  return (
    <div className="navbar">
      <input type="checkbox" id="nav__checkbox" class="nav__checkbox" />
      <label htmlFor="nav__checkbox" className="menu"> </label>
      <div className="title">
        <img src={image} alt="titleImage" />
        <div>
          <h3>Hady Hesham</h3>
          <span>Frontend developer</span>
        </div>
      </div>
      <div className="links">
        <NavLink to="/" exact>
          home
        </NavLink>
        <NavLink to="/about" exact>
          about
        </NavLink>
        <NavLink to="/portfolio" exact>
          portfolio
        </NavLink>
        <NavLink to="/academy" exact>
          academy
        </NavLink>
        <NavLink to="/contact" exact>
          contact
        </NavLink>
        <NavLink to="/resume" exact>
          resume
        </NavLink>
      </div>
      <div className="Ar" exact></div>
    </div>
  );
}

export default Navbar;
